<template>
  <div class="os-history-item">
    <div class="os-history-item__header ">
      <div class="os-history-item__title">
        Изменение времени предзаказа
        <span class="os-history-item__time">/ {{ item.createdAt | asFormattedTime }}</span>
      </div>

      <user-info-label :user="item.user"/>
    </div>
    <div class="os-history-item__content">
      <before-after-log-item>
        <template v-slot:before>
          <label-with-icon icon="clock">
            {{ oldPreorderDate }}
          </label-with-icon>
        </template>
        <template v-slot:after>
          <label-with-icon icon="clock">
            {{ preorderDate }}
          </label-with-icon>
        </template>
      </before-after-log-item>
    </div>
  </div>
</template>

<script>
  import UserInfoLabel from '@/components/order-processing/order-components/history/order-state-history/items/parts/UserInfoLabel'
  import BeforeAfterLogItem
    from '@/components/order-processing/order-components/history/order-state-history/items/parts/BeforeAfterLogItem'
  import { formatIsoDateTimeAsShortYearDate, formatIsoDateTimeAsTime } from '@/util/date-time-helper'
  import LabelWithIcon
    from '@/components/order-processing/order-components/history/order-state-history/items/parts/LabelWithIcon'

  export default {
    name: 'HistoryItemTypePreorder',
    components: { LabelWithIcon, BeforeAfterLogItem, UserInfoLabel },
    props: {
      item: {
        type: Object,
        default: () => ({}),
      },
    },
    computed: {
      oldPreorderDate () {
        return this.item.oldPreorderDate
          ? formatIsoDateTimeAsTime(this.item.oldPreorderDate) + ' ' + formatIsoDateTimeAsShortYearDate(this.item.oldPreorderDate)
          : 'как можно скорее'
      },

      preorderDate () {
        return this.item.preorderDate
          ? formatIsoDateTimeAsTime(this.item.preorderDate) + ' ' + formatIsoDateTimeAsShortYearDate(this.item.preorderDate)
          : 'как можно скорее'
      },

    },
  }
</script>

<style lang="less" scoped>
@import "./../OrderStateHistoryItem.less";
</style>
